import { Routes, Route, Navigate } from "react-router";
import { useAuthStore } from "~/ui/auth/authStore";
import { LoginPage } from "~/ui/auth/LoginPage";
import { RequestAccountPage } from "~/ui/auth/RequestAccountPage";
import { ForgotPasswordPage } from "~/ui/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "~/ui/auth/ResetPasswordPage";
import { LandingPage } from "~/ui/landing/LandingPage";
import { ImpressumPage } from "~/ui/legal/ImpressumPage";
import { DatenschutzPage } from "~/ui/legal/DatenschutzPage";
import { AppLayout } from "~/ui/layout/AppLayout";
import { PatientsPage } from "~/ui/patients/PatientsPage";
import { InvoicesPage } from "~/ui/invoices/InvoicesPage";
import { ReportsPage } from "~/ui/reports/ReportsPage";
import { SettingsPage } from "~/ui/settings/SettingsPage";
import { AdminPage } from "~/ui/admin/AdminPage";
import { CatalogPage } from "~/ui/catalog/CatalogPage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.accessToken);
  return token ? <>{children}</> : <Navigate to="/login" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/request-account" element={<RequestAccountPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="/datenschutz" element={<DatenschutzPage />} />
      <Route
        path="/app"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/app/customers" replace />} />
        <Route path="customers" element={<PatientsPage />} />
        <Route path="customers/:id" element={<PatientsPage />} />
        <Route path="patients/*" element={<Navigate to="/app/customers" replace />} />
        <Route path="catalog" element={<CatalogPage />} />
        <Route path="invoices/*" element={<InvoicesPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
